/**
 * Zero-width space (U+200B) used to keep an empty draft heading addressable in
 * the live editor. Markdown serializers replace it with the canonical empty
 * section marker for persistence and remove it from presentation output.
 */
export const DRAFT_SECTION_SENTINEL = '\u200B';
